"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFieldView = void 0;
const tslib_1 = require("tslib");
const IkeModel = tslib_1.__importStar(require("@ikegps/core-shared"));
const core_shared_1 = require("@ikegps/core-shared");
const input_1 = require("../../../components/input/input");
const number_input_state_1 = require("../../../components/input/number.input.state");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const page_state_1 = require("../../../state/page.state");
const field_info_1 = require("../../field.info/field.info");
function getValue(field, inputState) {
    const value = field.value;
    if (!field.hasValue()) {
        return null;
    }
    if (field.isManual() || field.isSag()) {
        return value;
    }
    if (field.isBearing() || field.isBackBearing()) {
        const angle = core_shared_1.IkeUnit.convertAngle(value, core_shared_1.IkeUnit.DEGREE, core_shared_1.IkeUnit.RADIAN);
        return core_shared_1.IkeUnit.round(angle, inputState.precision);
    }
    return null;
}
exports.NumberFieldView = {
    viewInline(field) {
        if (field.isSag()) {
            return core_shared_1.IkeUnit.display(field.value, services_1.Services.UserSettings.units);
        }
        return field.displayValue;
    },
    hasDetail(field) {
        return !field.isManual() && field.getCaptures().length > 0;
    },
    viewDetail(field) {
        if (!exports.NumberFieldView.hasDetail(field)) {
            return null;
        }
        const collection = field.collection;
        if (field.isSag()) {
            const sagCaptures = core_shared_1.CollectionModelFieldNumberSagUtil.getSagCaptures(field);
            const p2pMeasurement = core_shared_1.MultiPoint.Points([sagCaptures.start, sagCaptures.end]);
            const stats = [
                { name: i18n_1.T.DISTANCE_SAG, value: field.value },
                { name: i18n_1.T.DISTANCE_VECTOR, value: field_info_1.FieldInfo.viewVectorInline(p2pMeasurement) },
                { name: i18n_1.T.DISTANCE_VERTICAL, value: Math.abs(p2pMeasurement.vertical) },
                { name: i18n_1.T.DISTANCE_HORIZONTAL, value: p2pMeasurement.horizontal }
            ];
            return field_info_1.FieldInfo.viewCaptures(collection, [sagCaptures.start, ...sagCaptures.points, sagCaptures.end], stats);
        }
        const captures = field.getCaptures();
        return field_info_1.FieldInfo.viewCaptures(collection, captures);
    },
    viewEdit(field, ctrl) {
        if (field.isSag()) {
            return exports.NumberFieldView.viewInline(field, ctrl);
        }
        let inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new number_input_state_1.NumberInputState(field.schema.displayName);
            inputState.onValue(() => {
                field.Mutator.manual(inputState.value);
            });
            inputState.setValue(getValue(field, inputState));
            ctrl.changeState.addState(field.id, inputState);
        }
        const onmouseover = () => {
            page_state_1.CurrentState.setHoverId(field.id);
        };
        const onmouseout = () => {
            page_state_1.CurrentState.setHoverId(null);
        };
        const className = input_1.Input.CSS.container;
        return (0, mithril_1.m)('div', { className, onmouseover, onmouseout, onclick }, [
            input_1.Input.view(inputState)
        ]);
    },
    hasClear(field) {
        return field.provider === IkeModel.CollectionModelFieldNumber.PROVIDER_SAG;
    }
};
//# sourceMappingURL=number.field.view.js.map